<template>
  <v-card
    :flat="isFlat"
    class="py-3 mt-3"
  >
    <form-group title="Consulta OFAC">
      <v-row>
        <v-col cols="12">
          <analysis-ofac-list
            v-model="payload.ofac"
            :loading="isLoading"
          />
        </v-col>
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import AnalysisOfacList from 'Modules/contacard/analysisTable/components/tables/AnalysisOfacList.vue';

export default {
  name: 'AnalysisOfacCard',
  components: { AnalysisOfacList },
  extends: AnalysisCardMixin,
};
</script>
